import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const TherapyCard = ({ title, description, imageSrc, link }) => {
  return (
    <motion.div
      className="therapy-card bg-white rounded-lg overflow-hidden card-shadow"
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
    >
      <div className="h-48 overflow-hidden">
        <img 
          src={imageSrc} 
          alt={title} 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-sharon-dark-green mb-2">{title}</h3>
        <p className="text-sharon-gray mb-4">{description}</p>
        <Link 
          to={link} 
          className="inline-block sharon-btn text-white"
        >
          קרא עוד
        </Link>
      </div>
    </motion.div>
  );
};

export default TherapyCard;